import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { TrailListMobileTable } from "./TrailListMobileTable";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import { globalVariables } from "helper/globalVariables";
import { debounce } from "lodash";
import { client } from "helper/apolloConfig";
import { globalClasses } from "helper/globalClasses";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GetTrailCalenderByAuthId } from "redux/features/superAdminSlice/manageUsersSlice/manageUsersGql";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { Button } from "shared/Components/button";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import SearchBar from "shared/Components/search";
import Loader from "shared/Components/loader";
import ThreeDotMenu from "shared/Components/threeDotMenu";
import { useParams, useNavigate } from "react-router-dom";
import {
  getDogsByIdQuery,
} from "redux/features/dogSlice/dogGql";
import {
  deleteDogProfileMutation,
} from "redux/features/superAdminSlice/manageDogsSlice/manageDogsGql";
import { setDogProfile } from "redux/features/superAdminSlice/manageDogsSlice/manageDogsSlice";
const headData = [
  globalVariables.name,
  globalVariables.date,
  globalVariables.location,
  globalVariables.level,
  globalVariables.dogEnteredInTrail,
];

const MemberCalender = ({ role, editable = true, authId }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const modalRef = useRef();

  const { id } = useParams();

  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });

  const [search, setSearch] = useState("");

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const { tableDataCls, paginatedDataCls  } = globalClasses;

  const [
    getTrailCalender,
    { data: TrailCalenderData, loading: trailCalenderLoading },
  ] = useLazyQuery(GetTrailCalenderByAuthId);

  const TrailCalenderList =
    TrailCalenderData?.getTrialCalendarByAuthId?.data ?? [];
  useEffect(() => {
    handlePaginationData();
  }, []);

  const onSearch = (event) => {
    const value = event?.target?.value;
    setSearch(value);
  };
  const debouncedSearch = debounce(onSearch, 1000);

  useEffect(() => {
    handlePaginationData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handlePaginationData = (page = 1) => {
    getTrailCalender({
      variables: {
        pageNumber: page,
        pageSize: 10,
        search,
        role: role,
        authId: id,
      },
    });
  };

  const renderTableBody = () => {
    return TrailCalenderList.map((user) => (
      <tr key={user.name}>
        <td className={tableDataCls}>{user.name}</td>
        <td className={tableDataCls}>
          {moment(user.date).format(DEFAULT_DATE_FORMAT)}
        </td>
        <td className={tableDataCls}>{user.location}</td>
        <td className={tableDataCls}>
          {[...new Set(user.level.split(", ").map(s => s.trim()))].join(", ")}
        </td>
        <td className={tableDataCls}>{user.dogEntries || "-"}</td>
      </tr>
    ));
  };

  const { data, loading, error } = useQuery(getDogsByIdQuery, {
    variables: { authId },
    fetchPolicy: "no-cache",
  });

  const dogs = data?.getAllRegisteredDogsByAuthId || [];

  const threeDotData = [
    globalVariables.editProfile,
    globalVariables.viewDogHistory,
    globalVariables.deleteProfile,
  ];
  
  const headDogData = [
    globalVariables.dogName,
    globalVariables.enterRegisteredName,
    globalVariables.breed,
    globalVariables.dateOfBirth,
  ];

  const onSelectOption = async (option, data) => {
    switch (option) {
      case globalVariables.addDogHistory:
        navigate("/admin/manage/dogs/addHistory");
        break;
      case globalVariables.editProfile:
        dispatch(setDogProfile(data));
        navigate("/admin/manage/dogs/editProfile");
        break;
      case globalVariables.viewDogHistory: {
        navigate("/admin/manage/dogs/dogHistory?option=switchRole", {
          state: {
            dogId: data?.id,
            newDogId: data?.dog_id,
            ownerName: data?.owner_name,
          },
        });
        break;
      }

      case globalVariables.deleteProfile: {
        setDeleteLoading(true);
        try {
          const result = await client.mutate({
            mutation: deleteDogProfileMutation,
            variables: { id: data?.id },
          });

          setDeleteLoading(false);
          if (result?.data?.deleteRegisteredDogs) {
            modalRef.current.openModal();
            setApiData({
              ...apiData,
              title: globalVariables.success,
              desc: result?.data?.deleteRegisteredDogs?.message,
              type: "success",
            });
          }
        } catch (error) {
          setDeleteLoading(false);
          modalRef.current.openModal();
          setApiData({
            ...apiData,
            title: globalVariables.error,
            desc: error?.message,
            type: "pending",
          });
        }
        break;
      }
      default:
        break;
    }
  };


  const renderMobileTableBody = () => {
      return dogs.map((data, ind) => (
        <div key={data?.call_name} className="mb-5">
          <div className="flex flex-col p-4 border-b border-gray-200">
            <div className="flex flex-row justify-between">
              <span className="text-base font-semibold text-gray-900">
                {`${globalVariables.dog}: ${data?.call_name}`}
              </span>
            </div>
            <div className="mt-1" />
            <span className="text-sm font-normal text-gray-600">
              {`${globalVariables.breed}: ${data?.breed}`}
            </span>
            <div className="flex flex-row justify-between items-center mt-3">
              {editable ? (
                <Button
                  onClick={() => {
                    navigate("/admin/manage/dogs/dogHistory", {
                      state: {
                        dogId: data?.id,
                        newDogId: data?.dog_id,
                        ownerName: data?.owner_name,
                      },
                    });
                  }}
                  label={globalVariables.viewMore}
                  width="w-[104px]"
                />
              ) : (
                <span className="text-sm font-normal text-gray-600">{`${
                  globalVariables.status
                }: ${data?.status ?? "-"}`}</span>
              )}
            </div>
          </div>
        </div>
      ));
    };

  const renderDogTableBody = () => {
    return dogs.map((data, ind) => (
      <tr
        key={data?.call_name}
        className={role === 'Super Admin' ? "cursor-pointer" : "cursor-default"}
        onClick={() => {
          if (editable) {
            navigate("/admin/manage/dogs/dogHistory", {
              state: {
                dogId: data?.id,
                newDogId: data?.dog_id,
                ownerName: data?.owner_name,
              },
            });
          }
        }}
      >
        <td className={paginatedDataCls(ind)}>{data?.call_name ?? "-"}</td>
        <td className={paginatedDataCls(ind)}>{data?.registration_name ?? "N/A"}</td>
        <td className={paginatedDataCls(ind)}>{data?.breed ?? "-"}</td>
        <td className={paginatedDataCls(ind)}>
          {data?.date_of_birth ? moment(data?.date_of_birth).format("MM/DD/YYYY") : "-"}
        </td>
        {editable && (
          <td className={paginatedDataCls(ind)}>
            <div
              className="flex  items-center justify-center"
              onClick={() => setSelectedIndex(ind)}
            >
              {deleteLoading && ind === selectedIndex ? (
                <Loader />
              ) : (
                <ThreeDotMenu
                  onClickDot={() => setSelectedIndex(ind)}
                  options={threeDotData}
                  dynamicHeight
                  onSelectOption={(option) => {
                    onSelectOption(option, data);
                  }}
                  threeDotWidth="w-[20px]"
                />
              )}
            </div>
          </td>
        )}
      </tr>
    ));
  };

  return (
    <div className="mt-4">
      {isMobile ? (
        <TableWithPagination
          title={globalVariables.dogs}
          tableBody={renderMobileTableBody()}
          loading={loading}
          error={error}
          isPagination={false}
        />
      ): (
        <TableWithPagination
          title={globalVariables.dogs}
          tableHeight={"md:h-[calc(100vh-10rem)] lg:h-[100vh]"}
          headData={editable ? [...headDogData, ""] : headDogData}
          tableBody={renderDogTableBody()}
          loading={loading}
          error={error}
          overflow="overflow-visible"
          isPagination={false}
        />
      )}
      <div className="flex flex-col flex-1 md:hidden">
        <span className="text-xl font-bold text-gray-900 px-4 pb-4">
          {globalVariables.trials}
        </span>
        <TrailListMobileTable
          data={TrailCalenderList}
          currentPage={TrailCalenderData?.getTrialCalendarByAuthId?.pageNumber}
          loading={trailCalenderLoading}
          handlePageChange={(page) => handlePaginationData(page)}
          totalPages={TrailCalenderData?.getTrialCalendarByAuthId?.totalPages}
        />
      </div>
      <div className="hidden md:block">
        <TableWithPagination
          isHeaderComponentRow={true}
          headerComponent={
            <SearchBar
              onChange={debouncedSearch}
              placeholder={globalVariables.search}
            />
          }
          totalPage={TrailCalenderData?.getTrialCalendarByAuthId?.totalPages}
          handlePageChange={(page) => handlePaginationData(page)}
          headData={headData}
          tableBody={renderTableBody()}
          itemsPerPage={10}
          tableHeight="h-[45rem]"
          loading={trailCalenderLoading}
          title={globalVariables.trials}
        />
      </div>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
      />
    </div>
  );
};

export default MemberCalender;
